import t from "./index651.js";
import { withInstall as o } from "./index604.js";
const a = o(t);
export {
  a as ElInput,
  a as default
};
